/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PublicSignerValidationErrorCode = {
    DuplicateField: 'duplicate_field',
    FieldNotFound: 'field_not_found',
    FieldReadOnly: 'field_read_only',
    FieldNotOwned: 'field_not_owned',
    FieldLocked: 'field_locked',
    FieldKindMismatch: 'field_kind_mismatch',
    SignatureValueInvalid: 'signature_value_invalid',
    RadioOptionInvalid: 'radio_option_invalid',
    SnapshotIncomplete: 'snapshot_incomplete',
    DisclosureRequired: 'disclosure_required',
    FieldRequired: 'field_required',
} as const;
export type PublicSignerValidationErrorCode = typeof PublicSignerValidationErrorCode[keyof typeof PublicSignerValidationErrorCode];


export function instanceOfPublicSignerValidationErrorCode(value: any): boolean {
    for (const key in PublicSignerValidationErrorCode) {
        if (Object.prototype.hasOwnProperty.call(PublicSignerValidationErrorCode, key)) {
            if (PublicSignerValidationErrorCode[key as keyof typeof PublicSignerValidationErrorCode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PublicSignerValidationErrorCodeFromJSON(json: any): PublicSignerValidationErrorCode {
    return PublicSignerValidationErrorCodeFromJSONTyped(json, false);
}

export function PublicSignerValidationErrorCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicSignerValidationErrorCode {
    return json as PublicSignerValidationErrorCode;
}

export function PublicSignerValidationErrorCodeToJSON(value?: PublicSignerValidationErrorCode | null): any {
    return value as any;
}

export function PublicSignerValidationErrorCodeToJSONTyped(value: any, ignoreDiscriminator: boolean): PublicSignerValidationErrorCode {
    return value as PublicSignerValidationErrorCode;
}

